import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export function copyToClipboard(_x) {
  return _copyToClipboard.apply(this, arguments);
}
function _copyToClipboard() {
  _copyToClipboard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(content) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof navigator !== 'undefined')) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return navigator.clipboard.writeText(content);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _copyToClipboard.apply(this, arguments);
}